package app.bloomey.web.theme

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.silk.components.style.addVariant
import com.varabyte.kobweb.silk.components.text.SpanTextStyle
import org.jetbrains.compose.web.css.px

val SpanTextHeader1Variant by SpanTextStyle.addVariant {
    base {
        Modifier.fontSize(24.px)
            .fontWeight(FontWeight.SemiBold)
    }
}